const NotFound = () => {
  return (
    <svg
      id="Vrstva_1"
      data-name="Vrstva 1"
      xmlns="http://www.w3.org/2000/svg"
      width="180.6mm"
      height="180.6mm"
      baseProfile="tiny"
      version="1.2"
      viewBox="0 0 511.9 511.9"
      className="mt-0.5 h-5 w-5"
    >
      <g id="_01_align_center" data-name=" 01 align center">
        <polygon
          points="326.3 155.6 256 225.8 185.7 155.6 155.6 185.7 225.8 256 155.6 326.3 185.7 356.4 256 286.2 326.3 356.4 356.4 326.3 286.2 256 356.4 185.7 326.3 155.6"
          fill="#e3e3e3"
          strokeWidth="0"
        />
        <path
          d="M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256,256-114.6,256-256C511.8,114.7,397.3.2,256,0ZM256,469.3c-117.8,0-213.3-95.5-213.3-213.3S138.2,42.7,256,42.7s213.3,95.5,213.3,213.3c-.1,117.8-95.6,213.2-213.3,213.3Z"
          fill="#e3e3e3"
          strokeWidth="0"
        />
      </g>
    </svg>
  )
}

export default NotFound
